<template>
    <DsSpinner v-if="loading" />

    <div v-else-if="isFailedAutoChargeAutomationEnabled">
        <header>{{ $t('funnel.edit.goal.integration.autoCharge.title') }}</header>
        <p>{{ $t('funnel.edit.goal.integration.autoCharge.failed') }}</p>

        <DsButton @click="updateConfig">
            {{ $t('global.save') }}
        </DsButton>
    </div>
</template>

<script>
import {
    createOrUpdateFailedAutoChargeConfig,
    getFailedAutoChargeConfig,
} from './failed.autocharge.api';

export default {
    components: {},
    props: {
        cell: {
            type: Object,
            required: true,
        },
        oracleId: {
            type: String,
            required: true,
        },
        flagsInfo: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['close-modal', 'update-config'],

    data() {
        return {
            loading: true,
        };
    },

    computed: {
        isFailedAutoChargeAutomationEnabled() {
            return this.flagsInfo.failedAutoChargeAutomationEnabled;
        },
    },

    async mounted() {
        if (this.oracleId) await getFailedAutoChargeConfig(this.oracleId);

        this.loading = false;
    },

    methods: {
        closeModal() {
            this.$emit('close-modal');
        },

        async updateConfig() {
            await createOrUpdateFailedAutoChargeConfig(this.oracleId, [], [], ['1']);

            this.$emit('update-config');
        },
    },
};
</script>

<style lang="scss" scoped>
header {
    line-height: $line-height-sm;
    font-size: $font-size-xs;
    margin-bottom: $spacing-100;
    color: $color-text-subtle;
}
</style>
